/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoadChainageDto } from '../../models/load-chainage-dto';

export interface GetLoadChainage$Params {
  id: string;

/**
 * Get terser output with fewer fields filled in
 */
  terse?: boolean;
}

export function getLoadChainage(http: HttpClient, rootUrl: string, params: GetLoadChainage$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadChainageDto>> {
  const rb = new RequestBuilder(rootUrl, getLoadChainage.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('terse', params.terse, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoadChainageDto>;
    })
  );
}

getLoadChainage.PATH = '/v1/loadchainages/{id}';
